import { AppointmentInfoComponent } from './components/appointment_info/appointment_info';
import { AppointmentRequestInfoComponent } from './components/appointment_request_info/appointment_request_info';
import { CarouselComponent } from './components/carousel/carousel';
import { ConsiderTodoCardController, ConsiderTodoComponent } from './components/consider_todo_card/consider_todo_card';
import { CustomCarouselComponent } from './components/custom_carousel/custom_carousel';
import {
  PathDetailChildrenComponent,
  PathDetailChildrenController
} from './components/my_path_task_detail_child/my_path_task_detail_child_controller';
import {
  PathDetailHeaderComponent,
  PathDetailHeaderController
} from './components/my_path_task_detail_header/my_path_task_detail_header';
import {
  TodosContentComponent,
  TodosContentController
} from './components/my_todos_content/my_todos_content_controller';
import { PathCheckboxComponent, PathCheckboxController } from './components/path_checkbox/path_checkbox';
import { PathTaskCardComponent, PathTaskCardController } from './components/path_task_card/path_task_card';
import {
  StaffTodoDetailsController,
  StaffTodoDetailsComponent
} from './components/staff_todo_details/staff_todo_details_controller';
import { TipCardComponent, TipCardController } from './components/tip_card/tip_card';
import { TipDetailsComponent, TipDetailsController } from './components/tip_details/tip_details_controller';
import { TodoDetailsComponent } from './components/todo_details/todo_details';
import { TodoPlacementTestComponent } from './components/todo_placement_test/todo_placement_test';
import {
  TodoRefreshButtonComponent,
  TodoRefreshButtonController
} from './components/todo_refresh_button/todo_refresh_button';
import {
  TodoReminderDetailsComponent,
  TodoReminderDetailsController
} from './components/todo_reminder_details/todo_reminder_details_controller';
import { TodoTaskFilterComponent, TodoTaskFilterController } from './components/todo_task_filter/todo_task_filter';
import { TopicContainerComponent } from './components/topic_container/topic_container';
import { TopicTileComponent, TopicTileController } from './components/topic_tile/topic_tile';
import {
  PathAutoCompleteModalComponent,
  PathAutoCompleteModalController
} from './modals/path_auto_complete_modal/what_is_auto_complete_modal';
import { PathModalService } from './modals/path_modal_service';
import {
  ReminderDatePickerModalComponent,
  ReminderDatePickerModalController
} from './modals/path_reminder_modal/reminder_date_picker_modal';
require('./data/main');

angular
  .module('capability-ng-todos', ['data-ng-todos'])
  .controller('ConsiderTodoController', ConsiderTodoCardController)
  .component('considerTodoCard', new ConsiderTodoComponent())
  .controller('TipCardController', TipCardController)
  .component('tipCard', new TipCardComponent())
  .controller('PathCheckboxController', PathCheckboxController)
  .component('pathCheckbox', new PathCheckboxComponent())
  .controller('PathDetailHeaderController', PathDetailHeaderController)
  .component('pathDetailHeader', new PathDetailHeaderComponent())
  .controller('TodoTaskFilterController', TodoTaskFilterController)
  .component('todoTaskFilter', new TodoTaskFilterComponent())
  .controller('PathTaskCardController', PathTaskCardController)
  .component('pathTaskCard', new PathTaskCardComponent())
  .controller('PathDetailChildrenController', PathDetailChildrenController)
  .component('pathDetailChildren', new PathDetailChildrenComponent())
  .controller('TodosContentController', TodosContentController)
  .component('todosContent', new TodosContentComponent())
  .service('ngPathModalService', PathModalService)
  .component('pathAutoCompleteModal', new PathAutoCompleteModalComponent())
  .controller('PathAutoCompleteModalController', PathAutoCompleteModalController)
  .component('staffTodoDetails', new StaffTodoDetailsComponent())
  .controller('StaffTodoDetailsController', StaffTodoDetailsController)
  .component('reminderDatePickerModal', new ReminderDatePickerModalComponent())
  .controller('ReminderDatePickerModalController', ReminderDatePickerModalController)
  .component('carousel', new CarouselComponent())
  .component('customCarousel', new CustomCarouselComponent())
  .component('todoRefreshButton', new TodoRefreshButtonComponent())
  .component('todoPlacementTest', new TodoPlacementTestComponent())
  .component('todoDetails', new TodoDetailsComponent())
  .component('appointmentInfo', new AppointmentInfoComponent())
  .component('appointmentRequestInfo', new AppointmentRequestInfoComponent())
  .controller('TodoRefreshButtonController', TodoRefreshButtonController)
  .component('todoReminderDetails', new TodoReminderDetailsComponent())
  .controller('TodoReminderDetailsController', TodoReminderDetailsController)
  .component('tipDetails', new TipDetailsComponent())
  .controller('TipDetailsController', TipDetailsController)
  .controller('TopicTileController', TopicTileController)
  .component('topic', new TopicTileComponent())
  .component('topicContainer', new TopicContainerComponent());

import './core';

export * from './modals/path_modal_service';
export * from './todo_interface';

// Exports from data-ng-todos module
export * from './data/services/path_color_service';
export * from './data/services/path_toggle_service';
export * from './data/services/todo_date_range_service';
export * from './data/services/task_detail_location_service';
export * from './data/services/my_todos_content_service';
export * from './data/services/todo_refresh_service';
export * from './data/services/intake_question_service';
export * from './data/services/intake_status_service';

export * from './data/queries/current_topics_query';
export * from './data/queries/appointment_request_priority_feed_query';
export * from './data/queries/to_do_priority_feed_query';

export * from './data/builders/path_topic_builder';
export * from './data/builders/path_item_builder';
export * from './data/builders/path_task_builder';

export * from './data/servants/to_do_builder_servant';

export * from './data/interfaces/todo_interface';

export * from './data/functions/path_task_formatter_fn';
export * from './data/functions/task_update_fn';

export const todos = 'capability-ng-todos';



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-todos/src/main.ts